import { useState } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { type FieldErrors, type StructureParams } from "./useTaskCreation";
import type { NumericParamKey } from "./TaskCreation";

export function StructureParamsSection(props: {
  params: StructureParams;
  fieldErrors: FieldErrors;
  disabled: boolean;
  onChange: <K extends keyof StructureParams>(
    key: K,
    value: StructureParams[K],
  ) => void;
}) {
  const [focusedField, setFocusedField] = useState<string | null>(null);

  function displayValue(key: NumericParamKey): number | string {
    let displayValueOutcome: number | string;
    if (focusedField === key && props.params[key] === 0) {
      displayValueOutcome = "";
    } else {
      displayValueOutcome = props.params[key];
    }
    return displayValueOutcome;
  }

  function handleNumericChange(key: NumericParamKey, rawValue: string) {
    const parsed = Number(rawValue);
    props.onChange(key, Number.isNaN(parsed) || parsed < 0 ? 0 : parsed);
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Параметры структуры</Typography>

      <TextField
        label="Количество списков"
        type="number"
        value={displayValue("listCount")}
        error={!!props.fieldErrors["structureParams.listCount"]}
        helperText={props.fieldErrors["structureParams.listCount"]}
        disabled={props.disabled}
        onChange={(event) => handleNumericChange("listCount", event.target.value)}
        onFocus={() => setFocusedField("listCount")}
        onBlur={() => setFocusedField(null)}
        inputProps={{ min: 0 }}
        size="small"
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        label="Количество таблиц"
        type="number"
        value={displayValue("tableCount")}
        error={!!props.fieldErrors["structureParams.tableCount"]}
        helperText={props.fieldErrors["structureParams.tableCount"]}
        disabled={props.disabled}
        onChange={(event) => handleNumericChange("tableCount", event.target.value)}
        onFocus={() => setFocusedField("tableCount")}
        onBlur={() => setFocusedField(null)}
        inputProps={{ min: 0 }}
        size="small"
        fullWidth
        sx={{ mb: 2 }}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={props.params.faqEnabled}
            disabled={props.disabled}
            onChange={(event) => props.onChange("faqEnabled", event.target.checked)}
          />
        }
        label="FAQ включён"
        sx={{ mb: 1 }}
      />

      {props.params.faqEnabled && (
        <TextField
          label="Количество вопросов FAQ"
          type="number"
          value={displayValue("faqQuestionCount")}
          error={!!props.fieldErrors["structureParams.faqQuestionCount"]}
          helperText={props.fieldErrors["structureParams.faqQuestionCount"]}
          disabled={props.disabled}
          onChange={(event) => handleNumericChange("faqQuestionCount", event.target.value)}
          onFocus={() => setFocusedField("faqQuestionCount")}
          onBlur={() => setFocusedField(null)}
          inputProps={{ min: 0 }}
          size="small"
          fullWidth
        />
      )}
    </Paper>
  );
}
